export type TShirtShortSizes = 'xs' | 'sm' | 'md' | 'lg' | 'xl';
export type TShirtLongSizes =
  | 'extra-small'
  | 'small'
  | 'medium'
  | 'large'
  | 'extra-large';
export type AllSizesTypes = TShirtShortSizes | TShirtLongSizes;

const tshirtShorthandMap: Record<TShirtLongSizes, TShirtShortSizes> = {
  'extra-small': 'xs',
  small: 'sm',
  medium: 'md',
  large: 'lg',
  'extra-large': 'xl',
};

const tshirtLonghandMap: Record<TShirtShortSizes, TShirtLongSizes> =
  Object.fromEntries(
    Object.entries(tshirtShorthandMap).map((entry) => entry.reverse())
  );

/**
 * @param {string} size
 * @returns {string} The shorthand size corresponding to the given longhand size, or `size` itself.
 */
export const toShorthandSize = (size: string): TShirtShortSizes =>
  tshirtShorthandMap[size as TShirtLongSizes] || size;

/**
 * @param {string} size
 * @returns {string} The longhand size corresponding to the given shorthand size, or `size` itself.
 */
export const toLonghandSize = (size: string): TShirtLongSizes =>
  tshirtLonghandMap[size as TShirtShortSizes] || size;
